import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { firebaseConnect } from 'react-redux-firebase'
import { routerActions } from 'react-router-redux'
import moment from 'moment'
import { userIsAuthenticated } from '../behaviors'

import * as assets from '../assets'
import * as UI from '../components'
import { formatDateTime, hasEarlyAccess } from '../helpers'

class Countdown extends React.Component {
  componentWillReceiveProps(newProps) {
    const {
      storefront: { startTime },
      profile,
      redirectToAllocation,
    } = newProps

    if (profile.isLoaded) {
      if (hasEarlyAccess(profile)) {
        if (moment(startTime).isAfter(moment())) {
          redirectToAllocation()
        }
      }
    }
  }

  render() {
    const { storefront } = this.props

    return (
      <UI.Card image={assets.logo}>
        <UI.Text center size="massive">
          Congratulations!
        </UI.Text>

        <UI.Divider hidden />

        <UI.Text center>
          You’ve registered for the {storefront.tokenName} Sale. Stay tuned for
          exciting announcements.
        </UI.Text>

        <UI.Divider hidden />

        <UI.Countdown to={storefront.startTime} />

        <UI.Divider hidden />

        <UI.Text center>
          The sale starts on {formatDateTime(storefront.startTime)}
        </UI.Text>
      </UI.Card>
    )
  }
}

const selectors = createStructuredSelector({
  storefront: (state, { storefront }) => storefront,
  profile: ({ firebase }) => firebase.profile,
})

const actions = (dispatch, props) => ({
  redirectToAllocation: () => dispatch(routerActions.replace('/')),
})

export default compose(
  firebaseConnect(),
  connect(selectors, actions),
  userIsAuthenticated()
)(Countdown)



// WEBPACK FOOTER //
// ./src/screens/Countdown.js